import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Grid, Button, Paper, Typography } from '@mui/material'

import Input from "./Input";
import { login, register } from "../../actions/auth";
import useStyles from './styles';

const Auth = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const [formData, setFormData] = useState({firstName:'', lastName:'', email:'', password:'', confirmPassword:''})
    const [registering, setRegistering] = useState(false)
    const [showPwdSate, setShowPwdState] = useState(false)

    const switchPages = () => setRegistering( prev => !prev)
    const handleShowPwd = () => setShowPwdState( prev => !prev)

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
    }
    const handleSubmit = (e) => {
        e.preventDefault()
       registering ? dispatch(register(formData, history)) : dispatch(login(formData, history))
    }

    return ( 
        <Paper className={classes.paper} elevation={3}>
        <Typography gutterBottom className={classes.typography} variant='h4' align='center'>{registering ? 'Register' : 'Login'}</Typography>

        <form onSubmit={handleSubmit} autoComplete='off'>
            <Grid container spacing={2}>
                {
                    registering && (
                        <>
                        <Input half name='firstName' label='First Name' onChange={handleChange} autoFocus />
                        <Input half name='lastName' label='Last Name' onChange={handleChange} />
                        </>
                    )
                }
                
                <Input  type='email' name='email' label='Email Address' onChange={handleChange} />
                <Input type={showPwdSate ? 'text' : 'password'} name='password' label='Password' handleShowPwd={handleShowPwd} onChange={handleChange} />
                {
                    registering && (
                        <Input type='password' name='confirmPassword' label='Confirm Password' onChange={handleChange} />
                        )
                    }
            </Grid>

            <Button className={classes.button} fullWidth variant='contained' color='primary' type='submit'>{registering ? 'Register' : 'Login'}</Button>

            <Grid container justifyContent='center'>
                <Grid item>
                    <Button color='primary' onClick={switchPages}>
                    {registering ? 'Have an account? Log in': 'Lack an account? Register'}
                    </Button>
                </Grid>
            </Grid>
        </form>
        </Paper>
     );
}
 
export default Auth;